import React, { useEffect, useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';

import { productApi as api } from 'api/product';
import { FormComponent, Notifications } from 'shared';

function UploadFeatureFlag() {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [ffOps, setFFOps] = useState([]);

    const formFields = [
        {
            name: 'featureFlag',
            inputElement: 'select',
            label: 'Value',
            gridValue: 4,
            inputProps: { required: true, opts: ffOps },
        },
        { name: 'wipeList', inputElement: 'checkbox', label: 'Wipe List', gridValue: 2 },
        {
            name: 'customerFile',
            inputElement: 'file',
            label: 'Customer IDs',
            gridValue: 6,
            inputProps: { required: true },
        },
    ];

    const getFeatureFlags = async () => {
        const response = await api.getAssignableFeatureFlags();
        if (response.status === false) {
            setNotification({ text: `No features found ${response.msg}`, level: 'error' });
            const pleaseSelect = { text: 'Please Select', value: 0 };
            setFFOps([pleaseSelect]);
            return;
        }

        const ops = response.data.rows.map((row) => {
            const out = {};
            out.text = row.feature;
            out.value = row.id;
            return out;
        });

        const pleaseSelect = { text: 'Please Select', value: 0 };
        setFFOps([pleaseSelect].concat(ops));
    };

    useEffect(() => {
        getFeatureFlags();
    }, []);

    return (
        <div>
            <h1>Assign customers</h1>
            <Notifications options={notification} />
            {}
            <div>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const response = await api.uploadFeatureFlag(
                            formData.featureFlag,
                            formData.wipeList,
                            formData.customerFile,
                        );
                        if (response.status === false) {
                            setNotification({ text: `Unable to upload feature flag ${response.msg}`, level: 'error' });
                            return;
                        }

                        setNotification({ text: 'Success!', level: 'success' });
                        resetForm();
                    }}
                />
            </div>
        </div>
    );
}

export { UploadFeatureFlag };
